import React from 'react';
import {
  ListItem,
  ListItemText,
  Checkbox,
} from '@material-ui/core';

import classes from '../../css/getCSS';


const multipleListItem = (props) => {
  const classNames = [classes.facetSingleItem, classes.multipleItem];
  if (props.is_selected === 1) {
    classNames.push(classes.active);
  }
  return (
    <ListItem
      className={classNames.join(' ')}
      onClick={() => props.selectMultiple(props.facet, props.value)}
    >
      <Checkbox
        checked={props.is_selected === 1}
        tabIndex={-1}
        disableRipple
      />
      <ListItemText primary={props.display_value} />
    </ListItem>
  );
};

export default multipleListItem;



// WEBPACK FOOTER //
// ./src/search/components/MultipleListItem.js